/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-script-url */
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import $ from 'jquery';

function Teaching0205() {
	let location = useLocation();
	useEffect(() => {
		$(".qa_cell_hami .qb_q_hami").click(function () {
			if ($(this).parent().hasClass("active")) {
				$(this).siblings('.qb_a_hami').slideToggle();
				$(this).parent().removeClass("active");
			} else {
				$(this).siblings('.qb_a_hami').slideToggle();
				$(this).parent().addClass("active");
				document.getElementById("qb_a_hami_1").style.display = "flex";
				document.getElementById("qb_a_hami_2").style.display = "flex";
			}
		});
	}, [location])

	return (
		<div className="content_inpage">
			<div className="pagesize">
				<ul className="bread">
					<li><a href="/">首頁</a></li>
					<li><a href="/container/teaching">教學&QA</a></li>
					<li><a href="/container/teaching/Teaching0205">聲控兌品說明</a></li>
				</ul>

				<h2 className="tit_main">聲控兌品說明</h2>
				<div className="content_box_hami qa_box">
					<div className="qa_cell_hami">
						<div className="qb_q_hami">操作影片</div>
						<div id="qb_a_hami_1" className="qb_a_hami">
							<div>
								<p>① APP設定聲控兌品</p>
								{/*<a href={"/video/APP設定聲控兌品.mp4"} target="_blank" rel="noreferrer"> 1.使用放在local的影片2.使用放在app_icons的影片(不佔空間)*/}
								<a href={"https://ibobby.ai.hinet.net/app_icons/video/APP設定聲控兌品.mp4"} target="_blank" rel="noreferrer">
									<img src={require("../../image/hami_video_01.jpg").default} alt="img_step_index03" />
								</a>
							</div>
							<div>
								<p>② APP查看訂單頁面</p>
								<a href={"https://ibobby.ai.hinet.net/app_icons/video/APP查看訂單頁面.mp4"} target="_blank" rel="noreferrer">
									<img src={require("../../image/hami_video_02.jpg").default} alt="hami_video_02" />
								</a>
							</div>
							<div>
								<p>③ APP修改資料</p>
								<a href={"https://ibobby.ai.hinet.net/app_icons/video/APP修改資料.mp4"} target="_blank" rel="noreferrer">
									<img src={require("../../image/hami_video_04.jpg").default} alt="hami_video_04" />
								</a>
							</div>
						</div>
						<div id="qb_a_hami_2" className="qb_a_hami">
							<div>
								<p>④ 商品兌換Demo</p>
								<a href={"https://ibobby.ai.hinet.net/app_icons/video/兌換商品Demo.mp4"} target="_blank" rel="noreferrer">
									<img src={require("../../image/hami_video_05.jpg").default} alt="hami_video_05" />
								</a>
							</div>
							<div>
								<p>⑤ 商品兌換與QA</p>
								<a href={"https://ibobby.ai.hinet.net/app_icons/video/兌換商品與QA.mp4"} target="_blank" rel="noreferrer">
									<img src={require("../../image/hami_video_06.jpg").default} alt="hami_video_06" />
								</a>
							</div>
							<div>
								<p>⑥ 點數不足&nbsp;</p>
								<a href={"https://ibobby.ai.hinet.net/app_icons/video/點數不足.mp4"} target="_blank" rel="noreferrer">
									<img src={require("../../image/hami_video_07.jpg").default} alt="hami_video_07" />
								</a>
							</div>
						</div>
						<a href="javascript:void(0);" className="btn_expand_hami"></a>
					</div>
				</div>
				<div className="content_box">
					<div className="steps steps_x3 flex_set">
						<div className="step_box flex_box">
							<div className="sb_num"><span>Step1</span></div>
							<div className="sb_img"><img src={require("../../image/img_step_hami01.png").default} alt="img_step_hami01" /></div>
							<div className="sb_txt">
								<p>至會員頁面，選擇「聲控兌品」。</p>
							</div>
						</div>
						<div className="step_box flex_box">
							<div className="sb_num"><span>Step2</span></div>
							<div className="sb_img"><img src={require("../../image/img_step_hami02.png").default} alt="img_step_hami02" /></div>
							<div className="sb_txt">
								<p>第一次會跳出設定說明，<br />順著指示點選【下一步】。</p>
							</div>
						</div>
						<div className="step_box flex_box">
							<div className="sb_num"><span>Step3</span></div>
							<div className="sb_img"><img src={require("../../image/img_step_hami03.png").default} alt="img_step_hami03" /></div>
							<div className="sb_txt">
								<p>完成填寫收件資料，<br />順著指示點選【下一步】。</p>
							</div>
						</div>
					</div>
					<div className="steps steps_x3 flex_set">
						<div className="step_box flex_box">
							<div className="sb_num"><span>Step4</span></div>
							<div className="sb_img"><img src={require("../../image/img_step_hami04.png").default} alt="img_step_hami04" /></div>
							<div className="sb_txt">
								<p>設定音箱的驗證PIN碼，<br />順著指示點選【設定完成】。</p>
							</div>
						</div>
						<div className="step_box flex_box">
							<div className="sb_num"><span>Step5</span></div>
							<div className="sb_img"><img src={require("../../image/img_step_hami05.png").default} alt="img_step_hami05" /></div>
							<div className="sb_txt">
								<p>進到「示範指令」頁面。<br />若是設定完成後再次點【聲控兌品】，會進到此頁面。<br />點擊右上角的【修改資料】，進到Step11的頁面修改收件資料與驗證碼。</p>
							</div>
						</div>
						<div className="step_box flex_box">
							<div className="sb_num"><span>Step6</span></div>
							<div className="sb_img"><img src={require("../../image/img_step_hami06.png").default} alt="img_step_hami06" /></div>
							<div className="sb_txt">
								<p>進入「商品清單」頁面。<br />點選【查看已兌換商品】，至Step7的畫面。<br />點擊【...收件地址23號】，至Step11的畫面修改收件資料<br />點擊右上角的【修改資料】，進到Step11的頁面修改收件資料與驗證碼。</p>
							</div>
						</div>
					</div>
					<div className="steps steps_x3 flex_set">
						<div className="step_box">
							<div className="sb_num"><span>Step7</span></div>
							<div className="sb_img"><img src={require("../../image/img_step_hami07.jpg").default} alt="img_step_hami07" /></div>
							<div className="sb_txt">
								<p>進入「查看已兌換商品」頁面。</p>
							</div>
						</div>
						<div className="step_box">
							<div className="sb_num"><span>Step8</span></div>
							<div className="sb_img"><img src={require("../../image/img_step_hami08.png").default} alt="img_step_hami08" /></div>
							<div className="sb_txt">
								<p>至技能開通頁面，選擇「聲控兌品」的【開關】。<br />至Step2的畫面進行設定。</p>
							</div>
						</div>
						<div className="step_box">
							<div className="sb_num"><span>Step9</span></div>
							<div className="sb_img"><img src={require("../../image/img_step_hami09.png").default} alt="img_step_hami09" /></div>
							<div className="sb_txt">
								<p>至技能開通頁面，選擇【聲控兌品】。</p>
							</div>
						</div>
					</div>
					<div className="steps steps_x3 flex_set">
						<div className="step_box">
							<div className="sb_num"><span>Step10</span></div>
							<div className="sb_img"><img src={require("../../image/img_step_hami10.png").default} alt="img_step_hami10" /></div>
							<div className="sb_txt">
								<p>點擊【啟用】後，<br />至Step3的畫面進行設定。</p>
							</div>
						</div>
						<div className="step_box">
							<div className="sb_num"><span>Step11</span></div>
							<div className="sb_img"><img src={require("../../image/img_step_hami11.png").default} alt="img_step_hami11" /></div>
							<div className="sb_txt">
								<p>進入「修改收件資料」頁面。<br />點擊【儲存並變更驗證碼】，進到Step12的頁面。</p>
							</div>
						</div>
						<div className="step_box">
							<div className="sb_num"><span>Step12</span></div>
							<div className="sb_img"><img src={require("../../image/img_step_hami12.png").default} alt="img_step_hami12" /></div>
							<div className="sb_txt">
								<p>進入「修改驗證碼」頁面。</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default Teaching0205;